export const FLAG_GETTING_GENERAL_INCOME_TYPES = 'FLAG_GETTING_GENERAL_INCOME_TYPES';
export const GET_GENERAL_INCOME_TYPES = 'GET_GENERAL_INCOME_TYPES';
export const CLEAR_GENERAL_INCOME_TYPES = 'CLEAR_GENERAL_INCOME_TYPES';
